import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Header from 'shared/college-profile/components/right-rail/header';
import Card from 'src/components/Cards/Card';
import {withCommas} from 'shared/utils';
import Icon from 'shared/components/icon';
import styles from './styles.module.scss';

export default class RightRail extends React.Component {
  static propTypes = {
    collegeProfile: PropTypes.shape({
      college: PropTypes.shape({
        city: PropTypes.string.isRequired,
        logo: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        amount: PropTypes.number,
      }).isRequired,
    }).isRequired,
  };

  render() {
    const {
      collegeProfile: {
        college: {city, logo, name, state, amount},
      },
    } = this.props;

    return (
      <aside className="college-profile-right-rail" aria-labelledby="college-profile-college-name">
        <Card>
          <div className="college-profile-college-status-card">
            <Header {...{city, logo, name, state}} canEarn />
            <div className="college-profile-earnings-display">
              <p className="college-profile-earnings-display-title">Your Earnings</p>
              <p className="college-profile-earnings-display-amount">
                ${withCommas(Math.round(amount))}
              </p>
            </div>
            <div className={styles.linkContainer}>
              <Link to="/earnings-history">
                <Icon iconType="chart-line" className={styles.linkIcon} />
                View Earnings History
              </Link>
            </div>
          </div>
        </Card>
      </aside>
    );
  }
}
